import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edb91db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-actions pt-4 mr-4" }

import ClientsTable from '@/components/Client/ClientsTable.vue';
import useAppMixin from '@/mixins/appMixin';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';
import { DEFAULT_PAGINATION_PAGE,PAGINATION_TABLES_NAMES,ROUTE_KEYWORDS } from '@/utils/constants';
import { onBeforeRouteLeave,useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Clients',
  setup(__props) {

const router = useRouter();

const { setPageTitle } = useAppMixin();
setPageTitle('PageTitle.Clients.Default');
const { handleUpdatePage } = useTablePaginationMixin();

function gotToCreate(type: string) {
  switch (type) {
      case 'single':
        router.push({ name: 'CreateSingleClient' });
        break;
      case 'group':
        router.push({ name: 'CreateGroupClients' });
        break;
      default:
        return false;
  }
}

onBeforeRouteLeave((to) => {
  if (!to.path.includes(ROUTE_KEYWORDS.CLIENT)) {
    handleUpdatePage(PAGINATION_TABLES_NAMES.CLIENTS, DEFAULT_PAGINATION_PAGE);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_menu, { transition: "slide-y-transition" }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              "prepend-icon": "mdi-plus",
              variant: "flat",
              color: "primary"
            }, props), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Button.CreateClient')), 1)
              ]),
              _: 2
            }, 1040)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "add-client-menu-body-btn",
              "prepend-icon": "mdi-account",
              color: "primary",
              variant: "flat",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (gotToCreate('single')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Button.CreateSingleClient')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "add-client-menu-body-btn",
              "prepend-icon": "mdi-account-group",
              color: "primary",
              variant: "flat",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (gotToCreate('group')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Button.CreateGroupClient')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(ClientsTable)
    ]),
    _: 1
  }))
}
}

})